import { ConfigContext } from "@swiggy-private/checkout-core";
import { isEmpty, ErrorBoundary } from "@swiggy-private/core-ui";
import React, { memo, useContext } from "react";
import { Storage, SESSION_STORAGE_KEYS } from "@swiggy-private/core-ui";
import TurboPayment from "./TurboPayment";

function TurboPaymentPage() {
    const configContext = useContext(ConfigContext);
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    const data = configContext.turboPayConfig?.unwrapOr({});

    if (isEmpty(data) || !data?.uniqueId) {
        return null;
    }

    if (!isEmpty(data.billAmountShownOnCart)) {
        Storage.setItem(SESSION_STORAGE_KEYS.BILL_AMOUNT_SHOWN_ON_CART, data.billAmountShownOnCart);
    }

    return (
        <ErrorBoundary errorContent={null} errorFallback={data.onSDKError}>
            <TurboPayment
                showLoader={!!data.showLoader}
                onTurboPay={data.onTurboPay}
                hideEducationComms={!!data.hideEducationComms}
                onError={data.onError}
                onPaymentMethodChange={data.onPaymentMethodChange}
                uniqueId={data.uniqueId}
                onTurboPayImpressionEvent={data.onTurboPayImpressionEvent}
                onTurboPayClickEvent={data.onTurboPayClickEvent}
                onPaymentMethodChangeClickEvent={data.onPaymentMethodChangeClickEvent}
                billAmountShownOnCart={data.billAmountShownOnCart}
                handleViewDetailedBillClick={data.handleViewDetailedBillClick}
                renderFallback={data.renderFallback}
                onTurboStripImpressionEvent={data.onTurboStripImpressionEvent}
                onTurboStripClickEvent={data.onTurboStripClickEvent}
                onTooltipImpressionEvent={data.onTooltipImpressionEvent}
                onTooltipClickEvent={data.onTooltipClickEvent}
                onTurboLoaded={data.onTurboLoaded}
                clampDiscountText={data.clampDiscountText}
                isTurboV2={data.isTurboV2}
                cartTotal={data.cartTotal}
            />
        </ErrorBoundary>
    );
}

export default memo(TurboPaymentPage);
